<template>
  <div
    class="fixed inset-0 bg-gray-500 bg-opacity-30 flex items-center justify-center z-50 p-4 text-sm"
  >
    <div class="modal bg-white p-4 rounded-md shadow-md">
      <span class="font-semibold block">Are you sure you want to delete this application?</span>
      <span class="italic">This action cannot be undone</span>
      <div class="flex items-center justify-end gap-2 mt-4">
        <button
          @click="cancelDelete"
          class="border-[1px] border-gray-200 text-black px-4 py-2 rounded-md hover:bg-gray-200 transition-all duration-200"
        >
          Cancel
        </button>
        <button
          @click="deleteApplication"
          class="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition-all duration-200"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'
import { useApplicationsStore } from '@/stores/applications'
import { useRouter } from 'vue-router'

const router = useRouter()

const applicationsStore = useApplicationsStore()

const props = defineProps({
  applicationId: {
    type: String,
    required: true
  }
})
const emit = defineEmits(['close'])

const deleteApplication = async () => {
  try {
    await applicationsStore.deleteApplication(props.applicationId)
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    router.push('/jobs')
  } catch (error) {
    console.error('Failed to delete:', error)
  }
}

const cancelDelete = () => {
  emit('close')
}
</script>
